export default [
    {
        id: 1,
        name: "MUDR. IGOR JANÍK, PH.D.",
        branches: [1, 2, 3],
        text: `Držitel titulu Ph.D. v oboru chirurgie hlavy a krku. Chirurg, specialista na laserovou, estetickou a žilní chirurgii`,
        photoId: 1,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru chirurgie",
            "držitel licence ČLK pro obor chirurgie",
            "držitel licence pro laserovou estetickou chirurgii a všeobecnou chirurgii",
            "do r. 1996 – chirurgické oddělení v nemocnici Ostrava – Vítkovice",
            "od roku 1995 zařazen do přípravy k atestaci z plastické a rekonstrukční chirurgie",
            "člen Evropské laserové asociace",
            "člen Americké laserové asociace",
            "člen České lékařské společnosti J. E. Purkyně",
            "člen Společnosti laserové estetické chirurgie",
            "člen ČLS pro využití laserů v medicíně",
            "člen České flebiologické společnosti",
            "člen Společnosti plastické chirurgie",
            "aktivní účast na mnoha tuzemských i zahraničních seminářích a konferencích, spojená s prezentací výsledků LLC",
            "podílí se na aprobaci nových přístrojů, technologií a léčiv používaných v medicíně"
        ],
        video: "nWDaJayohvQ"
    },
    {
        id: 2,
        name: "PRIM. MUDR. BRONISLAV VŘESKÝ",
        branches: [1],
        text: `Atestovaný plastický chirurg`,
        photoId: 3,
        info: [
            "1983 - promoce na Lékařské fakultě Univerzity Palackého v Olomouci",
            "1986 - specializace chirurgie I. stupně",
            "1993 - specializace chirurgie II. stupně",
            "1999 - specializace plastická chirurgie",
            "více než 28 let praxe v oboru",
            "aktivní a pasivní účast na celostátních a zahraničních kongresech",
            "osvědčení ČLK o celoživotním vzdělávání",
        ],
        video: "ObhyPIVptUY"
    },
    {
        id: 3,
        name: "MUDR. MARTIN ROZPRÝM",
        branches: [1, 2, 3],
        text: `Atestovaný plastický chirurg`,
        photoId: 2,
        info: [
            "vystudoval Lékařskou fakultu UP v Olomouci, promoval v roce 1993",
            "chirurgická atestace v roce 1996",
            "atestovaný plastický chirurg (2002)",
            "do roku 1995 pracoval na chirurgické klinice FNsP Ostrava",
            "od roku 1995 pracuje v Centru plastické chirurgie a chirurgie ruky Fakultní nemocnice Ostrava",
            "spolupracoval s několika soukromými prestižními klinikami v Praze a Brně",
            "s Laserovým léčebným centrem spolupracuje od roku 2007"
        ],
        video: "DOCD773eF2M"
    },
    {
        id: 4,
        name: "MUDR. LADA HANUSKOVÁ",
        branches: [1],
        text: `Interní lékařka, obezitoložka, laserový a estetický specialista`,
        photoId: 4,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru interna",
            "držitelka licence ČLK pro obor interna",
            "členka České lékařské společnosti J. E. Purkyně",
            "členka České internistické společnosti",
            "členka České obezitologické společnosti",
            "členka České společnosti pro využití laserů v medicíně",
            "aktivní účast na mnoha tuzemských i zahraničních seminářích, spojená s prezentací výsledků LLC",
            "podílí se na aprobaci nových přístrojů, technologií a léčiv používaných v medicíně"
        ],
        video: "cC_bU6BFqi0"
    },
    {
        id: 5,
        name: "MUDR. MARTA HRBÁČKOVÁ",
        branches: [1, 3],
        text: `Kožní lékař, specialista na laserovou, korektivní a estetickou dermatologii`,
        photoId: 5,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru dermatovenerologie I.",
            "držitelka licence České lékařské komory pro obor dermatovenerologie",
            "členka Dermatovenerologické společnosti ČLS JEP",
            "členka Společnosti pro korektivní dermatologii a kosmetologii ČLS JEP",
            "členka Akné společnosti ČLS JEP",
            "členka International Society of Dermatology (ISD)",
            "členka Společnosti pro využití laseru v medicíně ČLS JEP",
            "aktivní účast na tuzemských i mezinárodních sympoziích"
        ],
        video: "z4VdaXWGU4c"
    }, {
        id: 6,
        name: "MUDR. KATEŘINA ŠIMEČKOVÁ",
        branches: [1, 2, 3],
        text: `Kožní lékař, specialista na laserovou, korektivní a estetickou dermatologii`,
        photoId: 6,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "specializovaná způsobilost v oboru dermatovenerologie (II. atestace z oboru dermatovenerologie)",
            "držitelka primářské licence ČLK pro obor dermatovenerologie",
            "držitelka diplomu celoživotního vzdělávání lékařů ČLK",
            "členka dermatovenerologické společnosti ČLS JEP",
            "členka České akademie dermatovenerologie",
            "členka České společnosti pro korektivní dermatologii",
            "aktivní účast na mnoha tuzemských i zahraničních seminářích, spojená s prezentací výsledků LLC"
        ],
        video: "93pBzQ2vJ58"
    }, {
        id: 7,
        name: "MUDR. EVA GALNOROVÁ",
        branches: [2],
        text: `Kožní lékař, specialista na laserovou, korektivní a estetickou dermatologii`,
        photoId: 7,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru dermatovenerologie I.",
            "držitelka licence České lékařské komory pro obor dermatovenerologie",
            "členka Dermatovenerologické společnosti ČLS JEP"
        ],
        video: "hm5lYjs7zW4"
    }, {
        id: 8,
        name: "MUDR. MIROSLAV SÝKORA",
        branches: [2],
        text: `Chirurg, specialista na cévní chirurgii`,
        photoId: 8,
        info: [
            "studium na Lékařské fakultě Univerzity Karlovy v Hradci Králové",
            "atestace z oboru všeobecné lékařství I.",
            "atestace z oboru všeobecná chirurgie I.",
            "nádstavbová atestace z cévní chirurgie",
            "člen Angiologické společnosti",
            "člen České flebologické společnosti",
            "člen České chirurgické společnosti",
            "člen Spolku českých lékařů",
            "autor odborných přednášek na českých i mezinárodních sympoziích",
            "publikace v odborných vědeckých časopisech",
        ]
    }, {
        id: 9,
        name: "MUDR. KAREL MATLER",
        branches: [1],
        text: `Specialista na problematiku vnitřního nosu, chrápání a laserovou léčbu v ORL`,
        photoId: 10,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru otorinolaryngologie I.",
            "atestace z oboru otorinolaryngologie II.",
            "držitel licence ČLK pro obor otorinolaryngologie",
            "člen České lékařské společnosti J. E. Purkyně",
            "člen České otorinolaryngologické společnosti",
            "rozsáhlá vědecká, přednášková a publikační činnost",
            "podílí se na aprobaci nových přístrojů, technologií a léčiv používaných v medicíně",
        ],
        video: "90eosIr6u3M"
    }, {
        id: 10,
        name: "MUDR. IVETA HILŠEROVÁ",
        branches: [2],
        text: `Kožní lékař, specialista na laserovou, korektivní a estetickou dermatologii`,
        photoId: 11,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru dermatovenerologie I.",
            "atestace z oboru dermatovenerologie II.",
            "členka Dermatovenerologické společnosti",
            "členka České společnosti pro využití laseru v medicíně",
            "členka European Academy of Dermatology and Venerology",
            "členka předsednictva Unie kosmetiček",
        ]
    }, {
        id: 11,
        name: "MUDR. MARTIN GRUSSMANN",
        branches: [3],
        text: `Chirurg, specialista na žilní chirurgii`,
        photoId: 9,
        info: [
            "chirurg, specialista na žilní chirurgii",
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru všeobecná chirurgie",
            "držitel licence ČLK pro obor chirurgie ",
            "dosud – chirurgické oddělení v nemocnici Opava, flebochirurgická a proktologická poradna",
            "spolupráce s Laserovým léčebným centrem od roku 2016",
            "aktivní účast na mnoha tuzemských i zahraničních seminářích a konferencích",
            "více než 20 let praxe v oboru",
            "člen České flebologické společnosti ",
        ],
        video: "AMOyhiiX_a4"
    },
    {
        id: 12,
        name: "MUDR. LUDMILA VESELÁ",
        branches: [1],
        text: `Kožní lékař, specialista na laserovou, korektivní a estetickou dermatologii`,
        photoId: 12,
        info: [
            "studium na Lékařské fakultě Univerzity Palackého v Olomouci",
            "atestace z oboru dermatologie I.",
            "atestace z oboru dermatologie II.",
            "držitelka licence ČLK pro obor dermatovenerologie",
            "členka České lékařské společnosti J. E. Purkyně",
            "členka České flebologické společnosti",
            "členka České dermatologické společnosti",
            "členka České společnosti pro korektivní dermatologii",
            "členka České společnosti pro využití laseru v medicíně",
            "aktivní účast na mnoha tuzemských i zahraničních seminářích, spojená s prezentací výsledků LLC",
            "podílí se na aprobaci nových přístrojů, technologií a léčiv používaných v medicíně"
        ],
        video: "5ZFcDZT5ayo"
    }
]



// WEBPACK FOOTER //
// ./src/texts/czech/doctors.js